module.exports = __webpack_public_path__ + "img/history-of-journalism.86e3d68e.jpg";